import React, { useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SearchIcon from "@mui/icons-material/Search";
import { esTelefonoValido } from "../Postventa/Dashboard/Helpers/esTelefonoValido";

// Columna de chats (Posventa/Cobranza) con segmented control y las dos secciones:
// requieren respuesta (destacados) y atendidos (apagados). Sin atender siempre primero.
export const MensajeriaColumnaChats = ({ titulo, icono, chats, onAbrirChat }) => {
    const [filtro, setFiltro] = useState("todos");
    const [busqueda, setBusqueda] = useState("");

    const chatsBuscados = chats.filter((c) =>
        c.nombre?.toUpperCase().includes(busqueda.toUpperCase())
    );

    const sinAtender = chatsBuscados.filter((c) => c.estado === "sin_atender");
    const atendidos = chatsBuscados.filter((c) => c.estado === "atendido");

    const chatsMostrados =
        filtro === "sinAtender" ? sinAtender :
        filtro === "atendidos" ? atendidos :
        [...sinAtender, ...atendidos];

    const mostrarSinAtender = filtro !== "atendidos";
    const mostrarAtendidos = filtro !== "sinAtender";

    return (
        <div className="mjr-columna">
            <div className="mjr-columna-header">
                <div className="mjr-columna-header-icono">{icono}</div>
                <h3 className="mjr-columna-titulo">{titulo}</h3>
                <span className="mjr-columna-badge">
                    {chats.length} total
                    {sinAtender.length > 0 && (
                        <span className="mjr-columna-badge-alerta">{sinAtender.length} sin atender</span>
                    )}
                </span>
            </div>

            <div className="mjr-buscador">
                <SearchIcon />
                <input
                    type="text"
                    placeholder="Buscar cliente..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                />
            </div>

            <div className="mjr-segmented">
                <button
                    className={filtro === "todos" ? "activo" : ""}
                    onClick={() => setFiltro("todos")}
                >
                    Todos
                </button>
                <button
                    className={filtro === "sinAtender" ? "activo" : ""}
                    onClick={() => setFiltro("sinAtender")}
                >
                    Sin atender ({sinAtender.length})
                </button>
                <button
                    className={filtro === "atendidos" ? "activo" : ""}
                    onClick={() => setFiltro("atendidos")}
                >
                    Atendidos ({atendidos.length})
                </button>
            </div>

            <div className="mjr-columna-lista scroll">
                {mostrarSinAtender && sinAtender.length > 0 && (
                    <>
                        <span className="mjr-lista-seccion">REQUIEREN RESPUESTA</span>
                        {sinAtender.map((chat) => (
                            <div
                                key={chat.id}
                                className="mjr-chat-card mjr-chat-urgente"
                                onClick={esTelefonoValido(chat.telefono) ? () => onAbrirChat(chat) : undefined}
                            >
                                <div className="mjr-chat-avatar">
                                    <span>{chat.iniciales}</span>
                                    <span className="mjr-chat-punto-no-leido" />
                                    <span className="mjr-chat-badge-wsp"><WhatsAppIcon /></span>
                                </div>
                                <div className="mjr-chat-info">
                                    <span className="mjr-chat-nombre">{chat.nombre}</span>
                                    <span className="mjr-chat-mensaje">{chat.mensaje}</span>
                                </div>
                                <span className="mjr-chat-tiempo mjr-chat-tiempo-urgente">{chat.tiempo}</span>
                            </div>
                        ))}
                    </>
                )}

                {mostrarAtendidos && atendidos.length > 0 && (
                    <>
                        <span className="mjr-lista-seccion">ATENDIDOS</span>
                        {atendidos.map((chat) => (
                            <div
                                key={chat.id}
                                className="mjr-chat-card mjr-chat-apagado"
                                onClick={esTelefonoValido(chat.telefono) ? () => onAbrirChat(chat) : undefined}
                            >
                                <div className="mjr-chat-avatar">
                                    <span>{chat.iniciales}</span>
                                    <span className="mjr-chat-badge-wsp"><WhatsAppIcon /></span>
                                </div>
                                <div className="mjr-chat-info">
                                    <span className="mjr-chat-nombre">{chat.nombre}</span>
                                    <span className="mjr-chat-mensaje">{chat.mensaje}</span>
                                </div>
                                <span className="mjr-chat-tiempo">{chat.tiempo}</span>
                            </div>
                        ))}
                    </>
                )}

                {chatsMostrados.length === 0 && (
                    <p className="mjr-lista-vacio">No hay chats en esta categoría.</p>
                )}
            </div>
        </div>
    );
};
